(() => {
  'use strict';
  const dialog = document.getElementById('cr-quick-contact');
  let returnFocus;
  function openContact(trigger) {
    if (!dialog || typeof dialog.showModal !== 'function') { window.location.assign('/pages/contact-us'); return; }
    if (dialog.open) return;
    returnFocus = trigger instanceof HTMLElement ? trigger : document.activeElement;
    dialog.showModal();
    document.documentElement.classList.add('cr-contact-open');
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
    const rewards = target.closest('[data-cr-rewards-open]');
    if (rewards) {
      const launcher = document.getElementById('bon-loyalty-btn');
      if (launcher) {
        event.preventDefault();
        const panel = document.getElementById('bon-iframe-container');
        if (!panel || getComputedStyle(panel).visibility === 'hidden' || getComputedStyle(panel).display === 'none') launcher.click();
      }
      // Keep the account route available if the rewards app cannot load.
      return;
    }
    const contact = target.closest('[data-cr-contact-open],a[href="#wp_popup_2700291"]');
    if (contact) { event.preventDefault(); event.stopImmediatePropagation(); openContact(contact); }
  }, true);
  const enquiry = new URLSearchParams(location.search).get('enquiry');
  if (enquiry === 'Loyalty programme') {
    const form = document.querySelector('.coverage-contact form');
    const message = form?.elements.namedItem('contact[Comment]');
    if (message && !message.value) {
      message.value = 'I have a question about the CAQA loyalty programme: ';
      form.querySelectorAll('[name="contact[inquiry]"]').forEach(input => { input.checked = input.value === 'General Inquiry'; });
    }
  }
  if (!dialog) return;
  dialog.querySelector('[data-cr-contact-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
  dialog.addEventListener('close', () => { document.documentElement.classList.remove('cr-contact-open'); if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true }); });
  if (dialog.querySelector('[data-cr-contact-success],[data-cr-contact-errors]') && location.hash === '#CRQuickContact') openContact();

  // Retain this campaign's targeting, lead checks and impression limits.
  // Replace only its fixed-position presentation with the native contact form.
  let attempts = 0;
  function connectCampaign() {
    const popup = window.Wishpond?.Popup?.popups?.[2700291];
    if (popup && !popup.crResponsiveContact) {
      popup.crResponsiveContact = true;
      popup.show = function(event) {
        event?.preventDefault?.();
        if (!this.socialCampaign.shown) this.increaseImpressionCount();
        this.socialCampaign.shown = true;
        openContact();
      };
      if (popup.showing?.()) { popup.close(); openContact(); }
      return;
    }
    if (!popup && ++attempts < 120) setTimeout(connectCampaign, 500);
  }
  connectCampaign();
})();
